import { connect } from "react-redux";
import SlateEditor from "../../shared/components/SlateEditor/editor";

const Guide = (props) => {
   const { carts } = props;
   return (
      <div className="header-introduction-container sale-post">
         {carts.content_order_instructions &&
            <div className="introduction-container">
               <div className="svg-next-icon" >
               </div>
               <div className="btn-close-wrapper">
                  <div className="svg-next-icon" ></div>
               </div>
               <div className="content-container">
                  <span className="title-introduction">
                     Hướng dẫn đặt hàng:
                  </span>
                  <div className="content-guide" >
                     <SlateEditor
                        valueDefault={carts.content_order_instructions}
                        readOnly={true}
                     />
                  </div>
               </div>
            </div>
         }
      </div>
   );
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};


export default connect(mapStateToProps, {})(Guide);